import { Injectable } from '@angular/core';
import { Either, Right } from 'purify-ts';
import { AuthRepositoryFailure } from '../../domain/auth/failure';
import { IAuthRepository } from '../../domain/auth/i-auth-repository';
import { AuthenticatedUser, PERMISSIONS } from '../../domain/auth/types';

@Injectable({
  providedIn: 'root',
})
export class FakeAuthRepository implements IAuthRepository {
  public async getMe(): Promise<Either<AuthRepositoryFailure, AuthenticatedUser>> {
    return Right({
      name: 'Marina Alves',
      email: 'marina.alves@netpark.com.br',
      roles: ['TD', 'RS'],
      roleDetails: [
        { role: 'TD', label: 'Treinamento e Desenvolvimento' },
        { role: 'RS', label: 'Recrutamento e Seleção' },
      ],
      scopeLabel: 'Netpark Comunicações',
      permissions: {
        [PERMISSIONS.messageView]: true,
        [PERMISSIONS.messageSend]: true,
        [PERMISSIONS.messageSendBulk]: true,
        [PERMISSIONS.templateView]: true,
        [PERMISSIONS.templateCreate]: true,
        [PERMISSIONS.templateDelete]: true,
      },
    });
  }
}
